export function fillEn(obj){
  [
    'description',
    'benefits',
    'name',
    'title',
    'short_description',
  ].map((field,index)=>{
    if (obj[field]){
      if (!obj[field].en || obj[field].en==='<p><br></p>')
        obj[field].en = obj[field].de
    }
  })
  return obj
}
